import React, { memo } from 'react';
import styles from './ZtText.module.less';

export default memo(({ data }) => {
  return data && data.content ? (
    <div className={styles.card}>
      <div
        className={styles.card_title}
        style={JSON.parse(data.attribute)}
        dangerouslySetInnerHTML={{ __html: data.content.text.replace(/\n/g, '</br>') }}
      />
    </div>
  ) : (
    ''
  );
});
